import config from "../../../config/config";

let host = config.backend_url.split("//").pop();
let token = localStorage.getItem("SESSION");
const now = new Date();
const nowCopy = new Date(now.getTime());
now.setDate(now.getDate() - 7);

export const specs = {
    swagger: "2.0",
    info: {
        description: "Securaze REST API\n\nNote: All fields designated as querystring parameters can be used as body fields.",
        version: "1.0.0",
        title: "Securaze API",
    },
    host: host,
    basePath: "/api",
    tags: [
        { name: "Authorization", description: "Login + logout routes" },
        { name: "Products", description: "Access to Securaze Products" },
        { name: "Users", description: "Securaze User Account management" },
        { name: "Logistics", description: "Logistic entity management" },
    ],
    schemes: ["https", "http"],
    paths: {
        "/products/load": {
            post: {
                tags: ["Products"],
                summary: "Load a single product by ProductID.",
                description: "",
                operationId: "loadProduct",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "CustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "ProductID",
                        description: "ID of product to load",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                    {
                        in: "query",
                        name: "ProductType",
                        description:
                            "Possible options: PC, Mobile, Storage. If not defined, will search all product types",
                        required: false,
                        type: "string",
                    },
                ],
                responses: {
                    200: { description: "Successfully loaded product" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/products/list": {
            post: {
                tags: ["Products"],
                summary: "Lists all products for a given Customer.",
                description: "",
                operationId: "listProducts",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "CustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Filters",
                        description: "Filters to query Products by\n\n<i>Available filters</i> :\nPC: Vendor, InventoryID, Notes, InventoryNumber, SKU, SerialNumber, Model, Chassis, ANumber, GroupName, CreatedAt (Object), LastModifiedAt (Object)\nMobile: Vendor, InventoryID, Notes, InventoryNumber, SKU, SerialNumber, Model, IMEI, IMEI2, ANumber, GroupName, CreatedAt (Object), LastModifiedAt (Object)\nStorage: Vendor, InventoryID, Notes, InventoryNumber, SKU, SerialNumber, Shredded, GroupName, CreatedAt (Object), LastModifiedAt (Object)\n<i>Note for CreatedAt and LastModifiedAt parameters:</i> If you omit the \"To\" parameter, you will add the Product.Field >= {From} criteria. If you omit the \"From\" parameter, you will add the Product.Field < {To} criteria. If you specify both, you will add the Product.Field >= {From} and Product.Field <= {To} criteria.",
                        required: false,
                        type: "object",
                        schema: {
                            example: {
                                CreatedAt: {
                                    From: now,
                                    To: nowCopy
                                },
                                IMEI: "355870090016830"
                            },
                        }
                    },
                    {
                        in: "query",
                        name: "Page",
                        description: "0-based number of page for paginated results",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "PageSize",
                        description: "Number of products to load per page",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                    {
                        in: "query",
                        name: "ProductType",
                        description:
                            "Possible options: PC, Mobile, Storage. If not defined, will search all product types",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "OrderField",
                        description: "Field to order by",
                        required: false,
                        type: "string",
                        enum: ["Vendor", "InventoryID", "InventoryNumber", "ProductType", "SerialNumber", "SKU", "CreatedAt", "LastModifiedAt", "WipeStatus", "VerificationStatus", "WipeStarted", "VerificationStarted"],
                    },
                    {
                        in: "query",
                        name: "OrderDirection",
                        description: "Order direction",
                        required: false,
                        type: "string",
                        enum: ["asc", "desc"],
                    },
                ],
                responses: {
                    200: { description: "Successfully listed PC products" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/products/search": {
            post: {
                tags: ["Products"],
                summary: "Finds product by Serial Number / IMEI.",
                description: "",
                operationId: "searchProducts",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "CustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "SearchInput",
                        description:
                            "The Serial Number or IMEI code of the device you're looking for",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    199: { description: "Found multiple products that fit criteria" },
                    200: { description: "Successfully found product" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/products/download-erasure-report": {
            post: {
                tags: ["Products"],
                summary:
                    "Downloads the erasure report for given product (if it exists).",
                description: "",
                operationId: "downloadErasureReport",
                consumes: ["application/json"],
                produces: ["application/pdf"],
                parameters: [
                    {
                        in: "query",
                        name: "CustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "ProductID",
                        description: "ID of product to download erasure report",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully downloaded erasure report" },
                    400: { description: "Invalid input/no report found" },
                    500: { description: "Server error" },
                },
            },
        },
        "/products/download-diagnose-report": {
            post: {
                tags: ["Products"],
                summary:
                    "Downloads the diagnose report for given product (if it exists).",
                description: "",
                operationId: "downloadDiagnoseReport",
                consumes: ["application/json"],
                produces: ["application/pdf"],
                parameters: [
                    {
                        in: "query",
                        name: "CustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "ProductID",
                        description: "ID of product to download diagnose report",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully downloaded diagnose report" },
                    400: { description: "Invalid input/no report found" },
                    500: { description: "Server error" },
                },
            },
        },
        "/products/download-xls-report": {
            post: {
                tags: ["Products"],
                summary:
                    "Downloads a list of products that conform to conditions in uploaded Excel file.",
                description: "",
                operationId: "downloadXlsReport",
                consumes: ["multipart/form-data"],
                parameters: [
                    {
                        in: "formData",
                        name: "File",
                        description:
                            "XLS file containing report list conditions",
                        required: true,
                        type: "file",
                    },
                    {
                        in: "formData",
                        name: "CustomerID",
                        description: "ID of Customer if using Token",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "formData",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "formData",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully downloaded reports." },
                    400: { description: "Invalid input/no report found" },
                    500: { description: "Server error" },
                },
            },
        },
        "/users/create": {
            post: {
                tags: ["Users"],
                summary: "Creates a new User",
                description: "",
                operationId: "createUser",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "FirstName",
                        description: "First Name of the new user",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "LastName",
                        description: "Last Name of the new user",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Email",
                        description: "User email",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "SendEmailNotification",
                        description: "Would you like to send an email notification to the new user?",
                        default: true,
                        required: false,
                        type: "boolean",
                    },
                    {
                        in: "query",
                        name: "PhoneNumber",
                        description: "User phone number",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Username",
                        description: "Username for the new user",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Password",
                        description: "Password for the new user",
                        required: true,
                        type: "string"
                    },
                    {
                        in: "query",
                        name: "Status",
                        description: "New user's status",
                        required: true,
                        type: "string",
                        enum: ["active", "inactive"],
                    },
                    {
                        in: "query",
                        name: "Role",
                        description: "New user's role",
                        required: true,
                        type: "string",
                        enum: ["Admin", "EndUser", "GroupAdmin", "GroupOperator", "Operator", "Restricted", "Supervisor"],
                    },
                    {
                        in: "query",
                        name: "IndividualLicensingEnabled",
                        description: "Enable individual licensing for the user.",
                        required: false,
                        type: "boolean",
                    },
                    {
                        in: "query",
                        name: "WorkBalance",
                        description: "Work credits",
                        required: false,
                        type: "number",
                    },
                    {
                        in: "query",
                        name: "MobileBalance",
                        description: "Mobile credits",
                        required: false,
                        type: "number",
                    },
                    {
                        in: "query",
                        name: "RemoteBalance",
                        description: "Remote credits",
                        required: false,
                        type: "number",
                    },
                    {
                        in: "query",
                        name: "CurrencyBalance",
                        description: "Currency credits",
                        required: false,
                        type: "number",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully created new user" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/users/list": {
            post: {
                tags: ["Users"],
                summary: "Lists all users for a given Customer.",
                description: "",
                operationId: "listUsers",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "Filters",
                        description: "Filters to query Users by",
                        required: false,
                        type: "object",
                    },
                    {
                        in: "query",
                        name: "Page",
                        description: "0-based number of page for paginated results",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "PageSize",
                        description: "Number of users to load per page",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token,
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully listed users" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/users/load": {
            post: {
                tags: ["Users"],
                summary: "Loads a single user.",
                description: "",
                operationId: "loadUser",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "UserID",
                        description: "ID of user to load",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully loaded user" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/users/save": {
            post: {
                tags: ["Users"],
                summary: "Updates a single user.",
                description: "",
                operationId: "updateUser",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "UserID",
                        description: "ID of user to update",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "FirstName",
                        description: "First Name of the user",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "LastName",
                        description: "Last Name of the user",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Email",
                        description: "User email",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "PhoneNumber",
                        description: "User phone number",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Username",
                        description: "Username for the user",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Password",
                        description: "Password for the user",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Status",
                        description: "User status",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "IndividualLicensingEnabled",
                        description: "Enable individual licensing for the user.",
                        required: false,
                        type: "boolean",
                    },
                    {
                        in: "query",
                        name: "WorkBalance",
                        description: "Work credits",
                        required: false,
                        type: "number",
                    },
                    {
                        in: "query",
                        name: "MobileBalance",
                        description: "Mobile credits",
                        required: false,
                        type: "number",
                    },
                    {
                        in: "query",
                        name: "RemoteBalance",
                        description: "Remote credits",
                        required: false,
                        type: "number",
                    },
                    {
                        in: "query",
                        name: "CurrencyBalance",
                        description: "Currency credits",
                        required: false,
                        type: "number",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully listed users" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/users/delete": {
            post: {
                tags: ["Users"],
                summary: "Deletes a single user.",
                description: "",
                operationId: "deleteUser",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "UserID",
                        description: "ID of user to delete",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully deleted user" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/users/update-balance": {
            post: {
                tags: ["Users"],
                summary: "Updates individual licensing and balance for a user.",
                description: "",
                operationId: "updateUserBalance",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "UserID",
                        description: "ID of user to update",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "IndividualLicensingEnabled",
                        description: "Enable individual licensing for the user.",
                        required: true,
                        type: "boolean",
                    },
                    {
                        in: "query",
                        name: "WorkBalance",
                        description: "Work credits",
                        required: false,
                        type: "number",
                    },
                    {
                        in: "query",
                        name: "MobileBalance",
                        description: "Mobile credits",
                        required: false,
                        type: "number",
                    },
                    {
                        in: "query",
                        name: "RemoteBalance",
                        description: "Remote credits",
                        required: false,
                        type: "number",
                    },
                    {
                        in: "query",
                        name: "CurrencyBalance",
                        description: "Currency credits",
                        required: false,
                        type: "number",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully deleted user" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/auth/login": {
            post: {
                tags: ["Authorization"],
                summary: "Logs user into the system",
                description: "",
                operationId: "loginUser",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        name: "Username",
                        in: "query",
                        description: "The user name for login",
                        required: true,
                        type: "string",
                    },
                    {
                        name: "Password",
                        in: "query",
                        description: "The password for login in clear text",
                        required: true,
                        type: "string",
                    },
                    {
                        name: "RememberMe",
                        in: "query",
                        description: "Extends the token lifetime",
                        required: true,
                        type: "boolean",
                    },
                ],
                responses: {
                    200: { description: "successful operation" },
                    400: { description: "Invalid username/password supplied" },
                    500: { description: "Server error" },
                },
            },
        },
        "/auth/logout": {
            post: {
                tags: ["Authorization"],
                summary: "Logs user out of the system",
                description: "",
                operationId: "logoutUser",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        name: "Token",
                        in: "query",
                        description: "User token provided at login",
                        required: true,
                        type: "string",
                        default: token
                    },
                    {
                        name: "ActiveCustomerID",
                        in: "query",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: true,
                        type: "string",
                    },
                ],
                responses: {
                    200: { description: "successful operation" },
                    400: { description: "Invalid data supplied" },
                    500: { description: "Server error" },
                },
            },
        },
        "/logistic/order/create": {
            post: {
                tags: ["Logistics"],
                summary: "Creates a new Order",
                description: "",
                operationId: "createOrder",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "ActiveCustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Name",
                        description: "Order name",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Description",
                        description: "Order Description",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Type",
                        description: "Order type",
                        required: true,
                        type: "string",
                        enum: ['pickup', 'delivery']
                    },
                    {
                        in: "query",
                        name: "Status",
                        description: "New order's status",
                        required: true,
                        type: "string",
                        enum: ["new", "scheduled", "inWarehouse", "onHold", "finished"],
                    },
                    {
                        in: "query",
                        name: "DefaultLanguage",
                        description: "Language for erasure reports on this order",
                        required: true,
                        type: "string",
                        enum: ["en", "de", "es"],
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully created new order" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/logistic/order/load": {
            post: {
                tags: ["Logistics"],
                summary: "Load a single order by OrderID.",
                description: "",
                operationId: "loadOrder",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "CustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "OrderID",
                        description: "ID of order to load",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully loaded order" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/logistic/order/list": {
            post: {
                tags: ["Logistics"],
                summary: "Lists all orders for a given Customer.",
                description: "",
                operationId: "listOrders",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "CustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Filters",
                        description: "Filters to query orders by",
                        required: false,
                        type: "object",
                    },
                    {
                        in: "query",
                        name: "Page",
                        description: "0-based number of page for paginated results",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "PageSize",
                        description: "Number of orders to load per page",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully listed orders" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/logistic/order/save": {
            post: {
                tags: ["Logistics"],
                summary: "Updates a single order.",
                description: "",
                operationId: "updateOrder",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "OrderID",
                        description: "ID of order to update",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "ActiveCustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Name",
                        description: "Order name",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Description",
                        description: "Order Description",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Type",
                        description: "Order type",
                        required: true,
                        type: "string",
                        enum: ['pickup', 'delivery']
                    },
                    {
                        in: "query",
                        name: "Status",
                        description: "Updated order status",
                        required: true,
                        type: "string",
                        enum: ["new", "scheduled", "inWarehouse", "onHold", "finished"],
                    },
                    {
                        in: "query",
                        name: "DefaultLanguage",
                        description: "Language for erasure reports on this order",
                        required: true,
                        type: "string",
                        enum: ["en", "de", "es"],
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully listed orders" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/logistic/order/delete": {
            post: {
                tags: ["Logistics"],
                summary: "Deletes a single order.",
                description: "",
                operationId: "deleteOrder",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "OrderID",
                        description: "ID of order to delete",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully deleted order" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/logistic/transport-colli/create": {
            post: {
                tags: ["Logistics"],
                summary: "Creates a new Transport Colli",
                description: "",
                operationId: "createTransportColli",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "ActiveCustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Name",
                        description: "Transport Colli name",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Description",
                        description: "Transport Colli Description",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Location",
                        description: "Transport Colli location",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Order",
                        description: "ID of the Order the new Transport Colli is on",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "ArrivedDate",
                        description: "Date when Transport Colli arrived",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully created new transport colli" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/logistic/transport-colli/load": {
            post: {
                tags: ["Logistics"],
                summary: "Load a single transport colli by TransportColliID.",
                description: "",
                operationId: "loadTransportColli",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "CustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "TransportColliID",
                        description: "ID of transport colli to load",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully loaded transport colli" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/logistic/transport-colli/list": {
            post: {
                tags: ["Logistics"],
                summary: "Lists all transport collies for a given Customer.",
                description: "",
                operationId: "listTransportCollis",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "CustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Filters",
                        description: "Filters to query transport collies by",
                        required: false,
                        type: "object",
                    },
                    {
                        in: "query",
                        name: "Page",
                        description: "0-based number of page for paginated results",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "PageSize",
                        description: "Number of transport collies to load per page",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully listed transport collies" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/logistic/transport-colli/save": {
            post: {
                tags: ["Logistics"],
                summary: "Updates a single transport colli.",
                description: "",
                operationId: "updateTransportColli",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "TransportColliID",
                        description: "ID of transport colli to update",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "ActiveCustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Name",
                        description: "Transport Colli name",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Description",
                        description: "Transport Colli Description",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Location",
                        description: "Transport Colli location",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Order",
                        description: "ID of the Order the new Transport Colli is on",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "ArrivedDate",
                        description: "Date when Transport Colli arrived",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully listed transport collies" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/logistic/transport-colli/delete": {
            post: {
                tags: ["Logistics"],
                summary: "Deletes a single transport colli.",
                description: "",
                operationId: "deleteTransportColli",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "TransportColliID",
                        description: "ID of transport colli to delete",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully deleted transport colli" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/logistic/colli/create": {
            post: {
                tags: ["Logistics"],
                summary: "Creates a new Colli",
                description: "",
                operationId: "createColli",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "ActiveCustomerID",
                        description: "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Name",
                        description: "Colli name",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Description",
                        description: "Colli Description",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "ColliTypeID",
                        description: "Colli type (box, palette, area...)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "HolderColliID",
                        description: "If this colli sits on another colli, this should point to the holder colli",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "WarehouseID",
                        description: "ID of warehouse where Colli is located",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "GradeIDs",
                        description: "Grading categories for this colli",
                        required: false,
                        type: "array",
                        items: { type: "string" }
                    },
                    {
                        in: "query",
                        name: "AllowedProductTypeIDs",
                        description: "Types of products which can exist on this colli",
                        required: false,
                        type: "array",
                        items: { type: "string" }
                    },
                    {
                        in: "query",
                        name: "Status",
                        description: "New colli's status",
                        required: true,
                        type: "string",
                        enum: ["active", "inactive"],
                    },
                    {
                        in: "query",
                        name: "ArrivedAt",
                        description: "Date when Colli arrived",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "DateStarted",
                        description: "Date when products on this Colli started being processed",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully created new colli" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/logistic/colli/load": {
            post: {
                tags: ["Logistics"],
                summary: "Load a single colli by ColliID.",
                description: "",
                operationId: "loadColli",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "CustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "ColliID",
                        description: "ID of colli to load",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully loaded colli" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/logistic/colli/list": {
            post: {
                tags: ["Logistics"],
                summary: "Lists all collis for a given Customer.",
                description: "",
                operationId: "listCollis",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "CustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Filters",
                        description: "Filters to query collis by",
                        required: false,
                        type: "object",
                    },
                    {
                        in: "query",
                        name: "Page",
                        description: "0-based number of page for paginated results",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "PageSize",
                        description: "Number of collis to load per page",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully listed collis" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/logistic/colli/save": {
            post: {
                tags: ["Logistics"],
                summary: "Updates a single colli.",
                description: "",
                operationId: "updateColli",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "ColliID",
                        description: "ID of colli to update",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "ActiveCustomerID",
                        description:
                            "ID of Customer (Only if using Token for authorization)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Name",
                        description: "Colli name",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Description",
                        description: "Colli Description",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "ColliTypeID",
                        description: "Colli type (box, palette, area...)",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "HolderColliID",
                        description: "If this colli sits on another colli, this should point to the holder colli",
                        required: false,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "WarehouseID",
                        description: "ID of warehouse where Colli is located",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "GradeIDs",
                        description: "Grading categories for this colli",
                        required: false,
                        type: "array",
                        items: { type: "string" }
                    },
                    {
                        in: "query",
                        name: "ProductTypeIDs",
                        description: "Types of products which can exist on this colli",
                        required: false,
                        type: "array",
                        items: { type: "string" }
                    },
                    {
                        in: "query",
                        name: "Status",
                        description: "New colli's status",
                        required: true,
                        type: "string",
                        enum: ["active", "inactive"],
                    },
                    {
                        in: "query",
                        name: "ArrivedAt",
                        description: "Date when Colli arrived",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "DateStarted",
                        description: "Date when products on this Colli started being processed",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully listed collis" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },
        "/logistic/colli/delete": {
            post: {
                tags: ["Logistics"],
                summary: "Deletes a single colli.",
                description: "",
                operationId: "deleteColli",
                consumes: ["application/json"],
                produces: ["application/json"],
                parameters: [
                    {
                        in: "query",
                        name: "ColliID",
                        description: "ID of colli to delete",
                        required: true,
                        type: "string",
                    },
                    {
                        in: "query",
                        name: "Token",
                        description: "Token generated at login",
                        required: false,
                        type: "string",
                        default: token
                    },
                    // {
                    //     in: "query",
                    //     name: "ApiKey",
                    //     description: "API key if received",
                    //     required: false,
                    //     type: "string",
                    // },
                ],
                responses: {
                    200: { description: "Successfully deleted colli" },
                    400: { description: "Invalid input" },
                    500: { description: "Server error" },
                },
            },
        },

    },
};
